import { render, staticRenderFns } from "./BizItems.vue?vue&type=template&id=0b91c1df&lang=pug"
import script from "./BizItems.vue?vue&type=script&lang=js"
export * from "./BizItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports